import React, { ChangeEvent } from "react";
import { Box, FormControl, TextField, Typography } from "@mui/material";
import Label from "../../../../../common/components/Label";
import { INumberOfSelectedCandidates } from "./CampaignSetupForm";
import StackWrapper from "../../StackWrapper";
import { COLOR_MAP } from "../../../../../constants/ColorNames";
import { getIsTriggeredFromFolder } from "../../../../../utils/whatsAppUtils";

interface IProps extends INumberOfSelectedCandidates {}

// Regular expression to allow only numbers
const regex = /^[0-9]*$/;

const SelectCandidate: React.FC<IProps> = ({
  handleUpdateNumberOfSelectedCandidates,
  numberOfSelectedCandidates,
  error,
  triggeredFromPage,
  isBulkCampaign,
  campaignContactableDetails,
}) => {
  /* condition for disable
   1. if triggeredFromPage is "srp" and  isBulkCampaign = false
   2. if triggeredFromPage is "folder" and  isBulkCampaign = false
   3. if triggeredFromPage is "cdp"
  */
  const isDisabled =
    (triggeredFromPage?.toLowerCase() === "srp" && !isBulkCampaign) ||
    (getIsTriggeredFromFolder(triggeredFromPage) && !isBulkCampaign) ||
    triggeredFromPage?.toLowerCase() === "cdp";

  const showError =
    !!error &&
    (!numberOfSelectedCandidates ||
      +numberOfSelectedCandidates === 0 ||
      (!!numberOfSelectedCandidates &&
        +numberOfSelectedCandidates > campaignContactableDetails.profileCount));

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    if (regex.test(value)) {
      handleUpdateNumberOfSelectedCandidates(value);
    }
  };

  return (
    <StackWrapper>
      <Label
        colorType="light"
        label="Select candidates"
        required
        labelFor="selectCandidates"
      />

      <Box
        sx={{
          display: "flex",
          border: `1px solid ${COLOR_MAP.BORDER_GREY}`,
          ...(!!error && !numberOfSelectedCandidates
            ? {
                borderColor: COLOR_MAP.ERROR,
              }
            : {}),
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        <FormControl sx={{ flexGrow: 1 }}>
          <TextField
            value={numberOfSelectedCandidates}
            onChange={handleChange}
            sx={{ "& fieldset": { border: "none" } }}
            disabled={isDisabled}
            autoComplete="off"
          />
        </FormControl>

        {!isDisabled && (
          <Box
            sx={{
              width: "100px",
              color: "#59566C",
              background: "#F6F6F7",
              paddingRight: "0 !important",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderLeft: `1px solid ${COLOR_MAP.BORDER_GREY}`,
            }}
          >
            <Typography sx={{ fontSize: 12 }}>
              Max value {campaignContactableDetails.profileCount}
            </Typography>
          </Box>
        )}
      </Box>
      {showError && (
        <Typography sx={{ color: COLOR_MAP.ERROR, fontSize: 12 }}>
          {error}
        </Typography>
      )}
    </StackWrapper>
  );
};

export default React.memo(SelectCandidate);
